import { getCountries, getCountryCallingCode, parsePhoneNumber } from "react-phone-number-input";

export const DEFAULT_PHONE_COUNTRY = "IN";

const regionNames = typeof Intl !== "undefined" && Intl.DisplayNames
  ? new Intl.DisplayNames(["en"], { type: "region" })
  : null;

const countryCodeToFlagEmoji = (countryCode) =>
  countryCode
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt()));

const getCountryLabel = (countryCode) => {
  const countryName = regionNames?.of(countryCode) || countryCode;
  const callingCode = getCountryCallingCode(countryCode);
  const flagEmoji = countryCodeToFlagEmoji(countryCode);
  return `${flagEmoji} ${countryName} (+${callingCode})`;
};

export const PHONE_COUNTRIES = getCountries()
  .map((countryCode) => ({
    code: countryCode,
    callingCode: `+${getCountryCallingCode(countryCode)}`,
    label: getCountryLabel(countryCode),
  }))
  .sort((a, b) => {
    if (a.code === DEFAULT_PHONE_COUNTRY) return -1;
    if (b.code === DEFAULT_PHONE_COUNTRY) return 1;
    return a.label.localeCompare(b.label);
  });

const stripPhoneSeparators = (value = "") => value.trim().replace(/[\s()-]/g, "");

export const buildPhoneNumber = (value = "", countryCode = DEFAULT_PHONE_COUNTRY) => {
  const compactValue = stripPhoneSeparators(value);

  if (!compactValue) {
    return "";
  }

  if (compactValue.startsWith("+")) {
    const parsed = parsePhoneNumber(compactValue);
    return parsed?.number || `+${compactValue.slice(1).replace(/\D/g, "")}`;
  }

  const localDigits = compactValue.replace(/\D/g, "");
  if (!localDigits) {
    return "";
  }

  const parsed = parsePhoneNumber(`+${getCountryCallingCode(countryCode)}${localDigits}`);
  return parsed?.number || `+${getCountryCallingCode(countryCode)}${localDigits}`;
};

export const extractPhoneParts = (value = "") => {
  const compactValue = stripPhoneSeparators(value);

  if (!compactValue) {
    return {
      countryCode: DEFAULT_PHONE_COUNTRY,
      localNumber: "",
    };
  }

  const parsed = parsePhoneNumber(compactValue.startsWith("+") ? compactValue : `+${compactValue}`);

  if (parsed?.country) {
    return {
      countryCode: parsed.country,
      localNumber: parsed.nationalNumber || "",
    };
  }

  return {
    countryCode: DEFAULT_PHONE_COUNTRY,
    localNumber: compactValue.replace(/\D/g, ""),
  };
};

export const isEmailAddress = (value = "") =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
